import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {UserService} from "../service/user.service";
import {EMAIL_PATTERN} from "../constants/validation.constants";
import {MESSAGE_TIMEOUT} from "../constants/global.constants";
import {TranslateService} from "@ngx-translate/core";
import {Language} from "../models/language";
import {Router} from "@angular/router";
import {HttpErrorResponse} from "@angular/common/http";
import {UserResponse} from "../interface/userResponse";

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent implements OnInit {

  currentLang: string = '';
  form: FormGroup;
  loginError: boolean = false;
  reservedIdentificationId: string | null = null;
  returnUrl: string | null = null;

  constructor(private formBuilder: FormBuilder, private userService: UserService, private router: Router, public translate: TranslateService) {
    this.form = this.createForgotForm();
    this.currentLang = this.translate.currentLang || Language.HY;
    this.translate.onLangChange.subscribe((event) => {
      this.currentLang = event.lang;
    });
  }

  ngOnInit() {
    this.reservedIdentificationId = history.state.reservedIdentificationId || null;
    this.returnUrl = history.state.returnUrl || null;
  }

  createForgotForm(): FormGroup {
    return this.formBuilder.group({
      email: [null, [Validators.required, Validators.pattern(EMAIL_PATTERN)]],
    });
  }

  sendResetLink() {
    this.form.markAllAsTouched();
    if (this.form.invalid) {
      return;
    }
    const email = this.lowercaseFirstLetter(this.form.value.email);
    this.userService.sendPasswordResetLink(email).subscribe((userResponse: UserResponse) => {
        this.router.navigate(['/verify-phone'], {
          state: {
            email: email,
            token: userResponse.resetPasswordToken,
            reservedIdentificationId: this.reservedIdentificationId,
            returnUrl: this.returnUrl
          }
        });
      },
      (error: HttpErrorResponse) => {
        if (error.status === 404 || error.status === 403) {
          this.loginError = true;
        }
      }
    );
  }

  resetErrorMessage() {
    this.loginError = false;
  }

  get loginFormControl() {
    return this.form.controls;
  }

  private lowercaseFirstLetter(str: string): string {
    return str.charAt(0).toLowerCase() + str.slice(1);
  }

  protected readonly Language = Language;
}
